module.exports = __webpack_public_path__ + "img/wxpay.ac2bb095.png";